import axios, { type AxiosRequestConfig } from "axios";
import { BASE_URL } from "../constants/api-end-pionts";

const patchApiService = async <T = any>(
  url: string,
  body: object,
  config: AxiosRequestConfig = {}
): Promise<T> => {
  const bearerToken = localStorage.getItem("token");

  const api = axios.create({
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearerToken}`,
    },
    ...config,
  });

  try {
    const response = await api.patch<T>(url, body);
    return response.data;
  } catch (error) {
    console.error("patchApiService error:", error);
    throw error;
  }
};

export default patchApiService;
